export default __webpack_public_path__ + "static/media/330_store05-nl-mobile.c8bd0b26.png";